var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutterLevel04(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.53 27H16v-4h38.66l4.42-5.28 3.07 2.57L56.53 27zm5.61 4.28l-3.07-2.57L54.66 34H16v4h40.53l5.61-6.72zm0 11l-3.07-2.57L54.66 45H16v4h40.53l5.61-6.72zm0 11l-3.07-2.57L54.66 56H16v4h40.53l5.61-6.72z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_level_0-4.a4ba5225.svg";
export { SvgC1RollerShutterLevel04 as ReactComponent };